import { useState } from 'react';
import { Collapse } from '@mui/material';
import { colorPrimarioTramite } from '../Documentos/coloresTramite';
import { leerPreferenciaAbierta, guardarPreferenciaAbierta } from './preferenciaAbierta';

const COLOR = colorPrimarioTramite('cobro');

/**
 * Una de las secciones de la cobranza de un trámite (pacto, plan de cuotas, pagos, bitácora): un
 * encabezado con título, un dato de resumen y las acciones de esa sección, y un cuerpo que se abre y
 * se cierra.
 *
 * - `acciones` va a la derecha del encabezado y NO abre ni cierra la sección al tocarlo (por eso el
 *   botón que abre/cierra es solo la parte de la izquierda: un botón adentro de otro no es HTML
 *   válido). Puede ser una función que recibe `{ abrir }`, para las acciones que necesitan que se vea
 *   el cuerpo (editar el pacto, agregar una gestión) aunque la sección esté cerrada.
 * - Recuerda cómo la dejó la persona (ver preferenciaAbierta), una preferencia por sección.
 */
export default function SeccionColapsable({ clave, titulo, icono, resumen, acciones, abiertaPorDefecto = true, children }) {
    const claveAlmacen = `cobranzaTramite.seccion.${clave}`;
    const [abierta, setAbierta] = useState(() => leerPreferenciaAbierta(claveAlmacen, abiertaPorDefecto));
    const idCuerpo = `cobranza-seccion-${clave}`;

    const cambiar = (siguiente) => {
        setAbierta(siguiente);
        guardarPreferenciaAbierta(claveAlmacen, siguiente);
    };
    const abrir = () => {
        if (!abierta) cambiar(true);
    };

    return (
        <section className="mb-3 rounded-4 overflow-hidden" style={{ border: '1px solid #e2e8f0' }}>
            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 px-3 py-2" style={{ background: '#f8fafc' }}>
                <button
                    type="button"
                    className="border-0 bg-transparent p-0 d-flex align-items-center flex-wrap gap-2 text-start flex-grow-1"
                    onClick={() => cambiar(!abierta)}
                    aria-expanded={abierta}
                    aria-controls={idCuerpo}
                >
                    <i
                        className="bi bi-chevron-right"
                        aria-hidden="true"
                        style={{ color: '#64748b', fontSize: '0.85rem', transition: 'transform 0.2s ease', transform: abierta ? 'rotate(90deg)' : 'none' }}
                    ></i>
                    <i className={`bi ${icono}`} aria-hidden="true" style={{ color: COLOR }}></i>
                    <span className="fw-bold" style={{ color: '#1e293b' }}>{titulo}</span>
                    {resumen && <span className="text-muted small">{resumen}</span>}
                </button>
                {acciones && (
                    <div className="d-flex gap-2 flex-wrap">
                        {typeof acciones === 'function' ? acciones({ abrir }) : acciones}
                    </div>
                )}
            </div>

            <Collapse in={abierta} unmountOnExit>
                <div id={idCuerpo} className="p-3">{children}</div>
            </Collapse>
        </section>
    );
}
